import * as $ from 'jquery';

const settings = {
	filterDropdown: '.js-filter-dropdown',
	filteredDropdown: '.js-filtered-dropdown',
}

let options;

const init = () => {
	// Set the initial values
	$(settings.filteredDropdown).each(function() {
		const $this = $(this);
		const $filter = $(settings.filterDropdown + '[data-filter-for-id="' + this.id + '"]');
		if ($this.val()) {
			// A previous value has been set, set the category too
			let filterValue = $this.find('option:selected').data('filter-value');
			if (!filterValue) {
				filterValue = $this.find('option:selected').data('filter-id');
			}
			$filter.val(filterValue);
			filterDropdown(filterValue, $this, false);
		} else {
			if (!$filter.val()) {
				// Blank slate
				hideDropdown($this);
			} else {
				// We have come back from failed validation with only the category set
				filterDropdown($filter.val(), $this, false);
			}
		}
	});

	// Add the change listener
	$(settings.filterDropdown).on('change', function() {
		const $this = $(this);
		const $target = $('#' + $this.data('filter-for-id'));
		filterDropdown($this.val(), $target, false);

		$(settings.filteredDropdown).next('.help-block').hide();
	});
	$(settings.filterDropdown).trigger('change');
}

const hideDropdown = ($dropdown) => {
	// Hide select and remove the select class from the input div to hide the dropdown arrow
	// This way the error message for the filtered dropdown will still show
	$dropdown.hide().closest('.input').removeClass('select');
}

const showDropdown = ($dropdown) => {
	$dropdown.show().closest('.input').addClass('select');
}

const filterOptionsToShow = (options, dataAttr, filterValue) => {
	return options.filter((i, option) => {
		const optFilterValue = option.getAttribute(dataAttr);
		return filterValue === optFilterValue;
	});
}

const filterDropdown = (filterValue, $dropdown, clearValue = true) => {
	if (filterValue) {
		// A filter value has been set - update the contents in the filtered dropdown
		showDropdown($dropdown);
		if (!options) {
			options = $dropdown.find('option').clone();
		}
		$dropdown.find('option').remove();
		let optionsToShow = filterOptionsToShow(options, 'data-filter-value', filterValue);

		if (!optionsToShow.length) {
			optionsToShow = filterOptionsToShow(options, 'data-filter-id', filterValue);

			$(optionsToShow).prop('selected', true);
			clearValue = false;
			hideDropdown($dropdown);
		}

		const optionsToApply = [options[0], ...optionsToShow.toArray()];
		$(optionsToApply).appendTo($dropdown);
	} else {
		hideDropdown($dropdown);
	}

	// Reset the value if required
	if (clearValue) {
		$dropdown.val('');
	}
}

init();
